const WizardProgress = ({ activeStep, t }) => {
  const steps = [t("Software Details"), t("Software Context"), t("Create")];

  return (
    <div className="software-wizard-progress">
      {steps.map((label, index) => (
        <div className="software-wizard-progress__item" key={label}>
          <span
            className={`software-wizard-progress__number ${
              activeStep === index + 1 ? "is-active" : ""
            }`}
          >
            {index + 1}
          </span>
          <span className={activeStep === index + 1 ? "is-active" : ""}>
            {label}
          </span>
          {index < steps.length - 1 && (
            <span className="software-wizard-progress__line" />
          )}
        </div>
      ))}
    </div>
  );
};

export default WizardProgress;

